'use strict';

angular.module('licensure.services')
    .factory('NationalRegistryIntegrationData', ['$http', '$q', function ($http, $q) {
        return {
            save: function (national_registry_integration_data) {
                var d = $q.defer();

                var method = 'POST';
                var url = apiLocation + '/api/NationalRegistryIntegrationData/';

                $http({
                    method: method,
                    url: url,
                    data: {
                        national_registry_integration_data: national_registry_integration_data
                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            }
        }
    }])
;